import * as React from 'react';

import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { ROUTE_STATIC_FAQ, ROUTE_STATIC_TERM } from 'constants/app';

import './Footer.scss';

export class Footer extends React.Component<{}, {}> {
  render() {
    return (
      <footer className="footer o-container">
        <span className="footer__copyright">
          <FormattedHTMLMessage id="footer.copyright"/>
        </span>
        <ul className="footer__navigation-ul">
          <li className="footer__navigation-li">
            <Link to={ROUTE_STATIC_FAQ}><FormattedMessage id="footer.faq"/></Link>
          </li>
          <li className="footer__navigation-li">
            <Link to={ROUTE_STATIC_TERM}><FormattedMessage id="footer.term"/></Link>
          </li>
        </ul>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Footer/Footer.tsx